import { getFieldsetLabelForField } from './elementUtils';

// HTML has no native "at least one of these checkboxes" constraint, so flag every
// box in an empty required group as invalid ourselves.
const syncRequiredCheckboxGroups = (form: HTMLFormElement) => {
	const groups = new Map<string, HTMLInputElement[]>();
	for (const el of form.querySelectorAll<HTMLInputElement>(
		'input[type="checkbox"][data-required-group]',
	)) {
		const group = el.name.replace(/\[[^\]]*\]$/, '');
		groups.set(group, [...(groups.get(group) ?? []), el]);
	}

	for (const boxes of groups.values()) {
		const message = boxes.some((box) => box.checked) ? '' : 'Please select at least one option';
		boxes.forEach((box) => box.setCustomValidity(message));
	}
};

export const getFormValidationErrors = (form: HTMLFormElement): FormFieldInfo[] => {
	const invalidFields: FormFieldInfo[] = [];

	syncRequiredCheckboxGroups(form);

	for (const el of form.elements) {
		if (
			!(
				el instanceof HTMLInputElement ||
				el instanceof HTMLTextAreaElement ||
				el instanceof HTMLSelectElement
			)
		) {
			continue;
		}

		if (el.validity.valid) {
			continue;
		}

		let name = el.name;
		let label = el.dataset.errorLabel || el.labels?.[0].textContent || '';
		if (
			el instanceof HTMLInputElement &&
			(el.type === 'radio' || el.dataset.requiredGroup !== undefined)
		) {
			name = el.name.replace(/\[[^\]]*\]$/, '');
			// don't show multiple errors for radio/checkbox group options
			if (invalidFields.find((f) => f.name === name)) {
				continue;
			}
			// use the fieldset legend/label text
			label = getFieldsetLabelForField(el) || '';
		}

		invalidFields.push({
			id: el.id,
			name,
			label,
			link: `${window.location.origin}${window.location.pathname}#${el.id}`,
		});
	}

	return invalidFields;
};

export interface FormFieldInfo {
	id: string;
	name: string;
	label: string;
	link: string;
}
